import { Injectable } from "@angular/core";

export interface Timer
{
    readonly elapsed?: number;

    start(): void;
    end(): number;
}

class DateTimer
    implements Timer
{
    #time: number;
    #elapsed: number;

    get elapsed(): number
    {
        return this.#elapsed;
    }

    start(): void
    {
        this.#time = Date.now();
    }

    end(): number
    {
        if (isNaN(this.#time))
        {
            throw new Error("Timer has not been started");
        }

        this.#elapsed = Date.now() - this.#time;

        this.#time = NaN;

        return this.#elapsed;
    }
}

class PerformanceTimer
    implements Timer
{
    #time: number;
    #elapsed: number;

    get elapsed(): number
    {
        return this.#elapsed;
    }

    start(): void
    {
        this.#time = performance.now();
    }

    end(): number
    {
        if (isNaN(this.#time))
        {
            throw new Error("Timer has not been started");
        }

        this.#elapsed = performance.now() - this.#time;

        this.#time = NaN;

        return this.#elapsed;
    }
}

@Injectable({
    providedIn: "root"
})
export class TimerService
{
    create(performance?: boolean): Timer
    {
        return performance
            ? new PerformanceTimer()
            : new DateTimer();
    }
}
